import { render, staticRenderFns } from "./ClienteDialogo.vue?vue&type=template&id=708ab648&"
import script from "./ClienteDialogo.vue?vue&type=script&lang=js&"
export * from "./ClienteDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports